<template>
  <div class="stand-activity">
    <second-menu-link-content>
      <template v-slot:header>
        <span>展位竞价</span>
      </template>
      <template v-slot:content>
        <div class="stand-activity-main">
          <div
            class="add-promotion"
          >
            <el-button
            v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1"
            :disabled="selecedList.length == 0"
            :class="selecedList.length == 0?'btn-black':'btn-blue'"
            @click="addActivities">发起竞价</el-button>
          </div>
          <div class="search">
            <span>分类：</span>
            <el-cascader
              clearable
              class="white w160"
              v-model="cateId"
              :options="classify"
              :props="defaultParams"
              placeholder="请选择分类"
              filterable
              :show-all-levels="false"
            ></el-cascader>
            <el-button class="btn-blue" @click="search">筛选</el-button>
          </div>
          <div class="table-img">
            <el-table :data="tableData" style="width: 100%"
                empty-text="请先选择分类筛选展位"
                v-loading="loading"
                @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" 
                  :selectable="checkSelectable"></el-table-column>
              <el-table-column prop="index" label="序号" width="80"></el-table-column>
              <el-table-column prop="goodsName" label="商品名称"></el-table-column>
              <el-table-column prop="supplierName" label="商品从属"></el-table-column>
              <el-table-column prop="overdueTime" label="到期时间" min-width="180px"></el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1?(scope.row.publishStatus === 0):false"
                    class="btn-text"
                    type="text"
                    @click="lookDetails(scope.row)"
                  >查看竞价</el-button>
                  <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1?scope.row.publishStatus == 1:false"
                    class="btn-text"
                    type="text"
                    @click="remove(scope.row.id)"
                  >撤销</el-button>
                  <el-button
                    v-if="operationList.indexOf(operationsBtns.roleSaleBoothManage)!==-1?(scope.row.id == null?true:false):false"
                    class="btn-text"
                    type="text"
                    @click="addGoods(scope.row.index)"
                  >添加平台商品</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </second-menu-link-content>
    <el-dialog
      title="发起竞价"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="竞价时间：" required>
          <el-col :span="11">
            <el-form-item prop="beginTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.beginTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">至</el-col>
          <el-col :span="11">
            <el-form-item prop="endTime">
              <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.endTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="到期时间：" prop="overdueTime">
          <el-date-picker type="datetime" placeholder="请选择时间" :picker-options="pickerOptions" v-model="ruleForm.overdueTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="起拍价格：" prop="basePrice">
          <el-input v-model="ruleForm.basePrice" placeholder="请输入起拍价格"></el-input>
        </el-form-item>
        <el-form-item label="竞价序位：" prop="anatomical">
          <span>{{ ruleForm.anatomical }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDBOperationPermission } from 'common/js/storage';
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBStandActivity from "models/db/standActivity.js";
import DBCommodity from "models/db/commodity.js";
const dbCommodity = new DBCommodity();
const dBStandActivity = new DBStandActivity();
export default {
  components: {
    SecondMenuLinkContent,
  },
  data() {
    // 此处自定义校验起拍价格
    var validateBasePrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入起拍价格'))
      }
      if (Number.isInteger(Number(value))) {
        if (value>0) {
          callback()
        } else {
          callback(new Error('起拍价格必须大于0'))
        }
      } else {
        callback(new Error('起拍价格必须为整数'))
      }
    }
    return {
      // 页面按钮权限
      operationsBtns: {
        roleSaleBoothManage: "ROLE_SALE_booth_manage"
      },
      classify: [],
      cateId: "",
      tableData: [],
      dialogVisible: false,
      loading: true,
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children",
        checkStrictly: false,
      },
      ruleForm: {
        beginTime: '',
        endTime: '',
        overdueTime: '',
        basePrice: '',
        anatomical: '', //竞价序位
      },
      rules: {
        beginTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        endTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        overdueTime: [
          {required: true, message: '请选择时间', trigger: 'change' }
        ],
        basePrice: [
          { required: true, validator: validateBasePrice, trigger: 'blur' },
        ],
      },
      //设置当前时间前不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate
      },
      selecedList: [] //选中的序号
    };
  },
  created() {
    let cateId = this.$route.query.cateId
    if (cateId) {
      this.cateId = Number(cateId)
    }
    this.operationList = getDBOperationPermission();
    this._getFristClassify()
    this._getStandActivityList();
  },
  methods: {
    // 判断表格多选框禁止选择
    checkSelectable(row) {
      return row.id == null;
    },
    // 所选中的商品数据
    handleSelectionChange(val) {
      this.selecedList = []
      val.map((val) => {
        this.selecedList.push(val.index)
      });
    },
    addActivities() {
      this.ruleForm.beginTime= ''
      this.ruleForm.endTime= ''
      this.ruleForm.overdueTime= ''
      this.ruleForm.basePrice= ''
      this.ruleForm.anatomical = ''
      let str = ''
      this.selecedList.map(i => {
        str += `, ${i}`
      })
      this.ruleForm.anatomical = str.substring(1)
      this.dialogVisible = true
    },
    selectableRange() {
      let date = new Date()
      let hour = date.getHours()
      hour = hour > 9 ? hour : '0' + hour
      let minute = date.getMinutes()
      minute = minute > 9 ? minute : '0' + minute
      let second = date.getSeconds()
      second = second > 9 ? second : '0' + second
      let time = `${hour}:${minute}:${second}`
      const selectableRange = `${time}-23:59:59`
      return selectableRange
    },
    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
    },
    // 获取展位列表
    _getStandActivityList() {
      let cateId
      if (this.$route.query.cateId) {
        cateId = Number(this.$route.query.cateId)
      } else {
        let length = this.cateId.length - 1;
        cateId = this.cateId[length];
      }
      if (cateId) {
        dBStandActivity.getStandActivityList(cateId).then(res => {
          if (res.success) {
            let arr = [];
            res.result.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.index = value.index;
              obj.goodsName = value.goodsName;
              obj.supplierName = value.supplierName;
              if (value.overdueTime) {
                obj.overdueTime = formaTimeToSecond(value.overdueTime);
              }
              obj.biddingStatus = value.biddingStatus;
              obj.publishStatus = value.publishStatus;
              obj.boothStatus = value.boothStatus;
              arr.push(obj);
            });
            this.tableData = arr;
            this.loading = false;
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        });
      } else {
        this.tableData = []
        this.loading = false;
      }
    },
    //获取一级分类
    _getFristClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          this.classify = res.result
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    // 搜索
    search() {
      let cateId;
      if (Array.isArray(this.cateId)) {
        let length = this.cateId.length - 1;
        cateId = this.cateId[length]
      } else {
        cateId = this.cateId
      }
      this.$router.push({
        path: "/admin/marketing/stand-activity/standActivity",
        query: {
          cateId: cateId
        }
      });
      if (this.cateId.length != 0) {
        this._getStandActivityList();
      } else {
        this.tableData = []
      }
    },
    // 点击查看详情
    lookDetails(row) {
      let cateId;
      if (Array.isArray(this.cateId)) {
        let length = this.cateId.length - 1;
        cateId = this.cateId[length]
      } else {
        cateId = this.cateId
      }
      this.$router.push({
        path: "/admin/marketing/stand-activity/lookDetails",
        query: {
          standId: row.id,
          cateId: cateId
        }
      });
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formaTimeToSecond(this.ruleForm.beginTime) >= formaTimeToSecond(this.ruleForm.endTime)) {
            this.$message({
              type: 'error',
              message: '竞价结束时间必须晚于竞价开始时间'
            });
            return
          }
          if (formaTimeToSecond(this.ruleForm.overdueTime) <= formaTimeToSecond(this.ruleForm.endTime)) {
            this.$message({
              type: 'error',
              message: '到期时间必须晚于竞价结束时间'
            });
            return
          }
          let length = this.cateId.length - 1;
          let data = {}
          let cateId
          if (Array.isArray(this.cateId)) {
            cateId = this.cateId[length]
          } else {
            cateId = this.cateId
          }
          data.cateId = cateId
          data.beginTime = formaTimeToSecond(this.ruleForm.beginTime)
          data.endTime = formaTimeToSecond(this.ruleForm.endTime)
          data.overdueTime = formaTimeToSecond(this.ruleForm.overdueTime)
          data.basePrice = this.ruleForm.basePrice
          data.list = this.selecedList
          dBStandActivity.getStandActivityAdd(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '发起竞价成功'
              });
              this._getStandActivityList();
              this.dialogVisible = false
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    remove(id) {
      this.$confirm("是否选择该商品从展位撤销？?", "撤销", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'bidding-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      })
        .then(() => {
          let data = { id };
          dBStandActivity.removeStand(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '展位删除成功'
              });
              this._getStandActivityList();
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          });
        })
    },
    addGoods(index) {
      let cateId;
      if (Array.isArray(this.cateId)) {
        let length = this.cateId.length - 1;
        cateId = this.cateId[length]
      } else {
        cateId = this.cateId
      }
      this.$router.push({
        path: "/admin/marketing/stand-activity/addGoods",
        query: {
          standIndex: index,
          cateId: cateId
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.stand-activity {
  width: 100%;
  height: 100%;
  .stand-activity-main {
    .add-promotion {
      margin-bottom: 16px;
    }
    .white {
      background: #fff;
    }
    .btn-black {
      background: #EEEEEE;
      color: #999999;
    }
    .search {
      padding: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .el-input {
        width: 320px;
      }
      .el-button {
        margin-left: 16px;
      }
      span {
        font-size: 14px;
      }
    }
  }
}
</style>
<style lang="scss">
.stand-activity {
  .el-dialog {
    margin-top: 24vh!important;
    .el-dialog__header {
      border-bottom: 1px solid #EEE;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
        line-height: 24px;
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 72px;
      border-top: 1px solid #EEE;
    }
    .el-dialog__body {
      padding-bottom: 0px;
      .el-form {
        padding: 20px 0px;
        .el-form-item__content {
          .el-input,
          .el-input__inner {
            height: 32px;
            background: rgba(245, 247, 250, 0.2);
          }
          .line {
            text-align: center;
          }
        }
        .el-form-item {
          margin-bottom: 16px;
        }
        .el-form-item:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
<style>
.bidding-messageBox .el-message-box__header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
</style>